export { AboutUsFeature } from "./lib/about-us";
export { getStaticProps } from "./lib/get-static-props";
